import { nanoid } from 'nanoid'

export const generateId = (size = 10) => {
  return nanoid(size)
}
